<template>
    <div><!-- 出貨單列印查詢 -->
        <CCard class="w-100">
            <CCardHeader>
                <strong>{{$t('OrderInfo_Vue.DeliverySearch')}}</strong>
            </CCardHeader>
            <CCardBody>
                    <CForm>
                        <div class="CForminline">
                            <div class="supplier">
                                <p>{{$t('OrderInfo_Vue.VendorId')}}：</p>
                                <input type="text" :disabled="isDisableVendorId"  v-model="deliveryQueryParam.vendorId">
                            </div>
                            <div class="date_range">
                                <p>{{$t('OrderInfo_Vue.OrderDate')}}：</p>
                                <date-picker :lang="'zh-tw'" format="YYYY-MM-DD" valueType="format" v-model="deliveryQueryParam.orderDateBegin"></date-picker>
                                <span>~</span>
                                <date-picker :lang="'zh-tw'" format="YYYY-MM-DD" valueType="format" v-model="deliveryQueryParam.orderDateEnd"></date-picker>
                            </div>
                            <div class="number_range">
                                <p>{{$t('OrderInfo_Vue.OrderNo')}}：</p>
                                <input type="text" v-model="deliveryQueryParam.orderNoBegin">
                                <span>~</span>
                                <input type="text" v-model="deliveryQueryParam.orderNoEnd">
                            </div>
                            <div class="btn_group">
                                <button type="button" class="btn btn-edit mr-2" @click="deliverySearchEvent">{{$t('Buttons.Query')}}</button>
                            </div>                            
                        </div>
                    </CForm>
            </CCardBody>
        </CCard>
    </div>
</template>

<script>
import { orderMixin } from '@/mixin/order'
export default {
    mixins: [orderMixin],
    data() {
        return {
            isDisableVendorId: false,
            deliveryQueryParam : {}
        }
    },
    props : {
    },
    methods: {
        checkSearchParam(){ //檢核條件
           const {orderDateBegin,orderDateEnd,orderNoBegin,orderNoEnd} =this.deliveryQueryParam;
           let errMsg = '';
           if(orderDateBegin && orderDateEnd){
               if(orderDateBegin>orderDateEnd){
                 errMsg='訂單日期區間錯誤，起始日不得大於終止日!';
               }
           }        
           if(orderNoBegin && orderNoEnd){
               if(orderNoBegin>orderNoEnd){
                 errMsg='訂單單號區間錯誤，起始單號不得大於終止單號!';
               }
           }
           if(errMsg){
                this.$alert(errMsg , '警告',{type: 'warning'});
                return false;
           }
           return true;
        },
        deliverySearchEvent (){
            if(!this.checkSearchParam()){
                return;
            }
            this.$emit('deliverySearch',this.deliveryQueryParam);
        },
    },
    computed: {
    },
	mounted() {
        let userInfo = this.$userInfo ;
        if(this.isMember){
            this.deliveryQueryParam.vendorId = userInfo.vendorId;
            this.isDisableVendorId =true;
        }
        this.getCacheQueryParam('Delivery_QueryParam' , this.deliveryQueryParam);
	},
    created() {        
    }
}
</script>

<style lang="scss" scoped>
.CForminline {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    > .form-group {
        margin-bottom: 0;
    }

    > .supplier, .date_range, .number_range, .watch, .check {
        display: flex;
        align-items: center;
        margin: .5rem 0;
        > p {
            margin-right: 1rem;
            margin-bottom: 0;
        }
        > .purchase_input {
            margin-bottom: 0;
        }
        > input {
            margin: 0 .5rem;
        }
    }
}

.purchase {
    width: 100%;
}

.btn-edit {
    background-color: #343b55;
    color: white;
}
</style>
